import { getRequestPathPattern } from "shared/api/getRequestPathPattern"

import Honeybadger from "@honeybadger-io/js"

import { RequestError, RequestErrorArgs } from "./RequestError"

export class ServerError extends RequestError {
  constructor(args: RequestErrorArgs) {
    super(args)
    this.name = "ServerError"
  }

  async notify() {
    let responseBody: string | null = null
    try {
      responseBody = this.response ? await this.response.clone().json() : null
    } catch {
      // ignore JSON parsing errors
    }

    const status = this.response?.status
    const method = (this.init?.method ?? "GET").toUpperCase()
    const name = status ? `${this.name}: ${status}` : this.name

    Honeybadger.notify(this, {
      name,
      message: this.message,
      stack: this.stack,
      fingerprint: `${name}:${method}:${getRequestPathPattern(this.path)}`,
      // The request body is left out on purpose: it can hold large customer payloads
      params: { method, path: this.path, responseBody }
    })
  }
}
